import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const dashboardViewEmbedRoute: InvariantRoute = {
	name: 'dashboard-view-embed',
	path: '/jira/dashboards/:dashboardId(\\d+)/embed',
	query: [],
	exact: true,
};
